import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {Formatter, SYSTEM_DATE_FORMAT, SYSTEM_TIME_FORMAT} from "../../core/services/formatter.service";
import moment from "moment";

export default class DateModel extends BaseModel {
  uuid = null;
  start_date = null;
  end_date = null;
  start_time = '10:00:00';
  end_time = '10:00:00';
  start_lot = null;
  title = null;

  rules = {
    start_date: 'required',
    end_date: 'required',
    start_time: 'required',
    end_time: 'required',
    start_lot: 'required'
  };

  attributeLabels = {
    start_date: i18n.t('Start Date'),
    start_time: i18n.t('Start Time'),
    end_date: i18n.t('End Date'),
    end_time: i18n.t('End Time'),
    start_lot: i18n.t('Starting Lot Number'),
    title: i18n.t('Title'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.uuid) {
      const startDate = this.start_date;
      const endDate = this.end_date;

      this.start_date = moment(startDate).format(SYSTEM_DATE_FORMAT);
      this.start_time = moment(startDate).format(SYSTEM_TIME_FORMAT);
      this.end_date = moment(endDate).format(SYSTEM_DATE_FORMAT);
      this.end_time = moment(endDate).format(SYSTEM_TIME_FORMAT);
    }

    this.initTranslatableFields(this)
  }

  toJSON() {
    const $this = super.toJSON();

    if ($this.start_date) {
      $this.start_date = Formatter.getDateAndTimeToSystemFormat($this.start_date, $this.start_time)
    }

    if ($this.end_date) {
      $this.end_date = Formatter.getDateAndTimeToSystemFormat($this.end_date, $this.end_time)
    }

    return $this;
  }
}

defineTranslatableProperties(DateModel);
